// useTimeExpired.js
import {ref} from 'vue';
import router from "@/router/router";
import useStepNavigation from "@/composables/useStepNavigation";

const timeExpired = ref(false );
const showExpiredMessage = ref( false );
const handleTimeExpired = () => {
    timeExpired.value = true;
    showExpiredMessage.value = true;

    const { curStep } = useStepNavigation();

    //If the time has expired move back to page one
    if(curStep.value > 1) {
        router.push('/step1/');
    }
}

export default function useTimeExpired() {
    return { timeExpired, showExpiredMessage, handleTimeExpired };
}
